import Swiper, { Navigation, Pagination, Keyboard, EffectFade, Controller, Scrollbar, Autoplay, A11y, Mousewheel } from 'swiper';

export default class SwiperCarousel {
  constructor(target, data) {
    this.target = target;
    this.data = data;
    this.swiper = null;

    this.createSlider();
  }

  createSlider() {
    if (this.target && this.data) {
      this.swiper = new Swiper(
        this.target, 
        {
          modules: [
            Navigation,
            Pagination,
            EffectFade,
            Controller,
            Scrollbar,
            Autoplay,
            Keyboard,
            A11y,
            Mousewheel
          ],
          ...this.data,
        }
      )
    // eslint-disable-next-line no-console
    } else console.error('No target element or settings provided to SwiperCarousel');

    return this.swiper;
  }
}